module.exports = __webpack_public_path__ + "img/blog5.8fe55a0a.jpg";